// eslint-disable-next-line no-promise-executor-return
const sleep = (msec) => new Promise((resolve) => setTimeout(resolve, msec));

export default sleep;
